<template>
    <div id="merchantHistory">
        <el-breadcrumb separator="/" style="background:#f3f3f4;height:27px;">
            <i class="prev_page lf" @click="$router.history.go(-1)"></i>
            <el-breadcrumb-item :to="{ path: '/setting/subAccount' }">系统设置</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/setting/merchant' }">服务商信息</el-breadcrumb-item>
            <el-breadcrumb-item>历史修改记录</el-breadcrumb-item>			
        </el-breadcrumb>
        <div class="allbox">
            <div class="heard">历史修改记录</div>
            <el-table :data="tableData" tooltip-effect="dark" style ="width: 100%" class="tableV1">
                <el-table-column label="时间" align="left"  prop="modifyTime">
                    <template slot-scope="scope">
                        <span :title="scope.row.modifyTime">
                            {{formatDateTime(scope.row.modifyTime)}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="审核状态" align="left"  prop="checkStatus">
                    <template  slot-scope="scope">
                        <span :title="scope.row.checkStatus" :class="'color'+scope.row.checkStatus">{{scope.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="160" align='center' fixed="right">
                    <template slot-scope="scope">
                        <el-button style="color:#1ab394;" type="text"  size="small" @click="getdetel(scope.row.id)">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-Page
                :size-change="handleSizeChange" 
                :current-change="handleCurrentChange" 
                :page-config="pageConfig"
            ></el-Page>
        </div>
    </div>
</template>

<script>
import API from '@/fetch/api'
export default {
    data(){
        return {
        pageConfig: {
            pageSize: 10,
            total: '',
            pageNumber: 1,
            pageSizes: [10, 20, 50 ],
            layout: 'slot,sizes, prev, pager, next, jumper'
        },
        tableData: [],
        }
    },
    mounted () {
        this.getinfo ()
    },
    methods:{
        //分页
        handleCurrentChange(val) { //当前页
                this.pageConfig.pageNumber = val;
                this.getinfo ()
            },
        handleSizeChange(val) { //每页条数
            this.pageConfig.pageNumber = 1;
            this.pageConfig.pageSize = val;
            this.getinfo ()
        },
        getinfo() {
            API.http({
                    fullUrl: '/merchant/history_info/list',
                    type:'get',
                    params:{
                        pageNumber:this.pageConfig.pageNumber,
                        pageSize:this.pageConfig.pageSize,
                    },
                }).then(res=>{
                    if(res.code==200){
                        this.pageConfig.total = res.data.total
                        let name = ''
                        res.data.dataList.forEach((it)=>{
                            switch(it.checkStatus){
                                case 0: //未提交审核
                                    name = '未提交审核'
                                    it.name = name
                                break
                                case 1: //待审核
                                    name = '待审核'
                                    it.name = name
                                break
                                case 2: //审核驳回
                                    name = '审核驳回'
                                    it.name = name
                                break
                                case 10: //审核通过
                                    name = '审核通过'
                                    it.name = name
                                break
                            }
                        })
                        this.tableData = res.data.dataList
                    }
                })
        },
        getdetel (id) {
            this.$router.push({
                name: 'merchant',
                query: {
                    id: id,
                    state:88,
                }
            })
        },
        //时间戳转换
        formatDateTime(inputTime) {
            if (inputTime == null) {
            inputTime = '/'
            } else {
            var date = new Date(inputTime);
            var y = date.getFullYear();
            var d = date.getDate();
            var m = date.getMonth() + 1;
            if (d < 10) {
                d = "0" + d
            }
            m = m < 10 ? ('0' + m) : m;
            return y + '-' + m + '-' + d;
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    #merchantHistory{
        .color0{ //未提交审核
            color: #FF4064
        }
        .color1{ //待审核
            color: #F0A55B;
        }
        .color2{ //审核驳回
            color: #FF4064
        }
        .color10{ //审核通过
            color: #1AB394
        }
    }
</style>